import { filterCustomerTemplates } from "@/api/message-template/filter-customer-templates";
import { getCustomerTemplateById } from "@/api/message-template/get-customer-template-by-id";
import { getCustomerTemplateTags } from "@/api/message-template/get-customer-template-tags";
import { updateCustomerTemplate } from "@/api/message-template/update-customer-template";
import { TemplateVariableGroup } from "@/constants/message-template.constants";
import { ICustomerTemplate, ICustomerTemplateInput } from "@/interfaces/customer-template.interface";
import { IFilter } from "@/types/filter.types";
import { PaginatedResponse, RequestPagination } from "@/types/requests.types";

class MessageTemplateService {
  // O backend já força RecordType = T na listagem.
  async filter(
    filter: IFilter<ICustomerTemplate>[],
    pagination: RequestPagination
  ): Promise<PaginatedResponse<ICustomerTemplate>> {
    return filterCustomerTemplates(filter, pagination);
  }

  async getById(id: number): Promise<ICustomerTemplate> {
    return getCustomerTemplateById(id);
  }

  async getTags(type?: string): Promise<TemplateVariableGroup[]> {
    return getCustomerTemplateTags(type);
  }

  async update(formData: ICustomerTemplateInput, id: number): Promise<void> {
    return updateCustomerTemplate(id, formData);
  }
}

const messageTemplateService = new MessageTemplateService();
export default messageTemplateService;
